<template>
	<div class="nk-tree d-flex flex-column h-100 pt-3">
		<div class="w-100 mr-0 pr-3 pl-3  tree-filter pb-3" v-if="settings.enableSearch">
			<icon icon="search" style="right: 20px" />
			<nk-input class="filter-input form-control" :options="inputOptions()" v-model="searchKeyword" @keydown.enter="agSearch"></nk-input>
		</div>
		<div class="tree-canvas">
			<ag-grid :data="filteredData" :options="agSettings" v-model="selectedNode" @pre-selected-row-data="nodeSelectedHandler" @row_dbClicked="rowDbClicked" @update:modelValue="nodeSelectedHandler" @rendered="$emit('rendered')" ref="grid"></ag-grid>
		</div>
	</div>

</template>

<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { isEmpty } from '@/statics/validators'
	import $sc from '@/plugins/shortcut.collection'
	import cloneDeep from 'lodash/cloneDeep'

	export default {
		name: "ag-tree",
		props: {
			data: Array,
			options: Object,
			modelValue: Object
		},
		emits: ['selected', 'rowDbClicked', 'rendered'],
		created() {
			_.merge(this.settings, this.options)
			_.merge(this.agSettings, this.options?.agOptions)
			const buttonsCellRendererParams = this.agSettings?.columnDefs && this.agSettings?.columnDefs.find(x => x.field === 'buttons')
			if (buttonsCellRendererParams) this.treeOperationFunctionAndPermissions = buttonsCellRendererParams.cellRendererParams && buttonsCellRendererParams.cellRendererParams()?.options
			if (this.settings.agOptions.rowModelType !== 'serverSide') {
				this.localData = this.data
				this.filteredData = this.localData

				this.prepareData()
			}
		},
		data() {
			return {
				selectedNode: null,
				searchKeywordLocal: '',
				searchTimeOut: null,
				searchFocusTimeOut: null,
				parents: [],

				agSettings: {
					groupDefaultExpanded: 0,
					cloneProps: false,
					enableSearch: true,
					// parentIdentifier: (data)=>data?.hasChild && data.id,
					doubleClickedToSelect: false,
					enterToSelect: true,
					rowGroupPanelShow: false,
					groupIncludeTotalFooter: false,
					cellSelectionAggReport: false,
					pagination: false,
					fitToWidth: false,
					sideBar: 'none',
					rowSelection: {
						mode: 'singleRow'
					},
					treeData: true,
					focusAndSelect: { allowFocus: true, updateSelected: 0 },
					isGroupOpenByDefault: (params) => {

					},
					getDataPath: (data) => {
						return data.hierarchy
					},
					defaultColDef: {
						floatingFilter: false,
					},
					autoGroupColumnDef: {
						valueFormatter: (params) => params.data?.name,
						filter: 'customString',
						// maxWidth: 400,
						// width:300,
						suppressSizeToFit: true,
						cellRendererParams: {
							suppressCount: true,
						},
					},
					columnDefs: [
						// {
						// 	field: 'name',
						// 	headerName: this.$t('row-number'),
						// 	contentType: 'string',
						// 	width: 80,
						// 	hidden: true
						// },

					],
				},
				settings: {
					enableSearch: true,
					searchPlaceholder: this.$t('operationClaim.search'),
					searchableFields: null,
					watchData: true,
					agOptions: {
						rowModelType: 'clientSide'
					}
				},
				treeOperationFunctionAndPermissions: null,
				localData: [],
				filteredData: [],
				treeItems: [],
				// treeOptions:{
				// 	doubleClickedToSelect: false,
				// 	enterToSelect: false,
				// 	rowGroupPanelShow: false,
				// 	groupIncludeTotalFooter: true,
				// 	cellSelectionAggReport: false,
				// 	pagination: false,
				// 	fitToWidth: false,
				// 	sideBar: 'none',
				// 	rowSelection: {
				// mode: 'singleRow'
				// },
				// 	treeData:true,
				// 	getDataPath:(data)=>{
				// 		return data.hierarchy;
				//
				// 	},
				//
				// 	autoGroupColumnDef:{
				// 		headerName: this.$t('account.f.name'),
				// 		contentType: 'enum',
				// 		valueFormatter:(params)=> params.data?.name,
				// 		filter: 'customString',
				// 		headerHeight: 0,
				// 		minWidth: 300,
				// 		cellRendererParams: {
				// 			suppressCount: true,
				// 		},
				// 	},
				// 	columnDefs: [
				// 		// {
				// 		// 	field: 'name',
				// 		// 	headerName: this.$t('row-number'),
				// 		// 	contentType: 'string',
				// 		// 	width: 80,
				// 		// 	hidden: true
				// 		// },
				//
				// 	],
				// },
			}
		},
		computed: {
			searchKeyword: {
				get() {
					return this.searchKeywordLocal
				},
				set(val) {
					this.searchKeywordLocal = val
					this.defer(() => {
						if (this.settings.agOptions.rowModelType === 'clientSide')
							this.delayedInputSearchKeyword(val)
						else if (!val)
							this.agSearch()
					}, 1)

				}
			},
		},
		watch: {
			data: {
				deep: true,
				handler() {
					if (this.settings.watchData) {
						this.watchDataHandler()
					}
				}
			},
			modelValue: {
				handler(val) {
					this.selectedNode = val
					this.defer(() => this.agSettings.focusAndSelect.updateSelected++, 1)
				}
			},
			'options.openNode': {
				deep: true,
				handler(value) {
					this.$refs.grid.rowGroupOpened({ data: value, expanded: true })
				}
			}
		},
		methods: {
			watchDataHandler() {
				if (this.settings.agOptions.rowModelType !== 'serverSide') {
					this.localData = _.clone(this.data)
					this.filteredData = this.localData
					this.prepareData()
					this.searchKeywordChanged(this.searchKeywordLocal, 5)
				}
			},
			rowDbClicked(data) {
				this.selectedNode = data
				this.$emit('rowDbClicked', data)
			},
			nodeSelectedHandler(data) {
				this.selectedNode = data
				this.$emit('selected', data)
			},
			inputOptions() {
				return {
					placeholder: this.settings.searchPlaceholder,
					mode: 'text'
				}
			},
			searchKeywordChanged(searchKeywordLocal, delay = 5000) {
				this.agSettings.focusAndSelect.allowFocus = false
				clearTimeout(this.searchFocusTimeOut)
				if (!searchKeywordLocal) {
					this.filteredData = this.localData
					this.agSettings.groupDefaultExpanded = 0

					// let nodeToSelected = this.selectedItem || _.head(this.treeNodes.filter(x => x.level === 1))
					// this.selectNode(nodeToSelected)
				} else {
					const words = searchKeywordLocal.getWords()
					// console.log('words', words)
					let fields = this.settings.searchableFields
					if (fields == null || !$.isArray(fields) || fields.length === 0) {
						fields = ['name']
					}

					if (words.length > 0) {
						this.filteredData = this.localData.filter((x) => { return fields.some(y => words.every(word => typeof x[y] === 'number' ? x[y].toString().includes(word) : x[y].includes(word))) })
						const addParent = (node) => {
							if (!isEmpty(node.parent?.id)) {
								var parent = this.localData.find(x => x.id === node.parent.id)
								if (parent != null) {
									if (this.filteredData.tryPush(parent, (a, b) => a.id === b.id)) {
										addParent(parent)
									}
								}
							}
						}

						// find parents
						for (let node of this.filteredData) {
							addParent(node)
						}

						this.agSettings.groupDefaultExpanded = -1
					}

				}
				this.searchFocusTimeOut = setTimeout(() => this.agSettings.focusAndSelect.allowFocus = true, delay)
			},
			delayedInputSearchKeyword(val) {
				clearTimeout(this.searchTimeOut)
				if (!val) this.searchKeywordChanged(val)
				else {
					this.searchTimeOut = setTimeout(() => {
						this.searchKeywordChanged(val)
						// this.searchKeywordLocal = val
					}, 500)
				}
			},
			agSearch(e) {
				if (this.settings.agOptions.rowModelType === 'serverSide') {
					const cloneFilter = cloneDeep(this.options.agOptions.serverInfo.payload.filter)
					const searchFields = this.settings.agOptions.serverInfo.searchableFields.reduce((a, x) => {
						if (typeof x === 'function') {
							if (!Array.isArray(a.SchemaValues)) a.SchemaValues = []
							a.SchemaValues.push(x(this.searchKeyword))
						} else
							a = { ...a, [x]: this.searchKeyword }
						return a
					}, cloneFilter)
					this.$refs.grid.serverInfo.payload.filter = { ...searchFields, searchTerm: this.searchKeyword }
					this.$refs.grid.expandedNodes.clear()
					this.$refs.grid.gridApi.refreshServerSide({ purge: true })
				}
			},
			prepareData() {
				if (Array.isArray(this.localData) && this.localData.length) {
					this.parents = Object.values([...new Map(this.localData.map(x => [typeof this.settings.parentIdentifier === 'function' && this.settings.parentIdentifier(x), x]))].filter(x => x[0])).map(x => x[1])

					const foundAllParent = (currentNode, parentId) => {
						const foundParent = parentId && this.parents.find(x => x.id === parentId)
						// console.log('foundParent',foundParent)
						let result
						if (foundParent) {
							currentNode.hierarchy.splice(0, 0, foundParent.id)
							result = foundAllParent(currentNode, foundParent?.parent?.id)
							// else {
							// 	currentNode.hierarchy.splice(0,0,currentNode.id)
							// 	result= currentNode
							// }
						} else {
							currentNode.hierarchy.push(currentNode.id)
							result = currentNode
						}
						return result
					}

					this.localData = this.localData.map(x => {
						return foundAllParent({ ...x, hierarchy: [] }, x?.parent?.id)
					})
					this.filteredData = this.localData
				}
			},
			subscribeKeys() {
				var tree = $(this.$el).find('.tree-canvas')
				var filter = $(this.$el).find('.filter-input')

				this.$keyHandler.Subscribe({
					name: 'tree-filter-clear',
					keyCode: 27, // 27:escape
					el: filter,
					context: this,
					// test: function () {
					// 	return !this.disabledTree
					// },
					handler: function (mainElement, e) {
						this.searchKeywordLocal = ''
						return true
					}
				}) // escape key - search
				this.$keyHandler.Subscribe({
					name: 'insert-account',
					shortcut: $sc.find('insert'),
					el: tree,
					context: this,
					// test: function () {
					// 	return !this.disabledTree && this.settings.editable
					// },
					handler: function () {
						if (this.selectedNode && this.treeOperationFunctionAndPermissions?.addPolicyClaimsState) {
							this.treeOperationFunctionAndPermissions.onNodeAddClicked && this.treeOperationFunctionAndPermissions.onNodeAddClicked(this.selectedNode)
							return true
						}
					}
				}) // insert
				this.$keyHandler.Subscribe({
					name: 'edit-account',
					shortcut: $sc.find('edit'),
					el: tree,
					context: this,
					// test: function () {
					// 	return !this.disabledTree && this.settings.editable
					// },
					handler: function () {
						if (this.selectedNode && this.treeOperationFunctionAndPermissions?.editPolicyClaimsState) {
							this.treeOperationFunctionAndPermissions.onNodeEditClicked && this.treeOperationFunctionAndPermissions.onNodeEditClicked(this.selectedNode)
							return true
						}
					}
				}) // edit
				this.$keyHandler.Subscribe({
					name: 'delete-account',
					shortcut: $sc.find('delete', 'account'),
					el: tree,
					context: this,
					// test: function () {
					// 	const nodeIsDeleteable = () => {
					// 		if (this.selectedItem == null) {
					// 			return false
					// 		}
					//
					// 		return !this.selectedItem.hasChild
					// 	}
					//
					// 	return !this.disabledTree && this.settings.editable && nodeIsDeleteable()
					// },
					handler: function () {
						if (this.selectedNode && this.treeOperationFunctionAndPermissions?.deletePolicyClaimsState) {
							this.treeOperationFunctionAndPermissions.onNodeDeleteClicked && this.treeOperationFunctionAndPermissions.onNodeDeleteClicked(this.selectedNode)
							return true
						}
					}
				}) // delete
			}
		}
	}
</script>

<style>
	.ag-root .ag-header {
		/*display: none;*/

	}
</style>